export const TOAST_TYPES = {
  DEFAULT: "default",
  INFO: "info",
  SUCCESS: "success",
  DANGER: "danger",
  WARNING: "warning",
};
